import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { PageLoader } from '@customerio/pluma-components/react';

const NewsletterFormSubmissionsPage = lazy(
  () => import('@/pages/workspaces/broadcasts/newsletter/overview/form-submissions/index.page'),
);

function NewsletterFormSubmissionsRoute() {
  const { newsletterId } = Route.useParams();
  return (
    <Suspense fallback={<PageLoader label="Loading…" />}>
      <NewsletterFormSubmissionsPage key={newsletterId} newsletterId={newsletterId} />
    </Suspense>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/form-submissions',
)({
  component: NewsletterFormSubmissionsRoute,
});
